import { Panel } from './Panel.tsx';

export const PanelC1: typeof Panel = Panel;
